import {CreateEmployeeFormValues} from './schema';

export type CreateEmployeeFieldConfig = {
    name: keyof CreateEmployeeFormValues;
    labelKey: string;
    type?: 'email' | 'tel';
    isRequired?: boolean;
};

export const CREATE_EMPLOYEE_FIELD_ROWS: CreateEmployeeFieldConfig[][] = [
    [
        {name: 'firstName', labelKey: 'first_name', isRequired: true},
        {name: 'lastName', labelKey: 'last_name', isRequired: true},
    ],
    [
        {name: 'middleName', labelKey: 'middle_name'},
        {name: 'email', labelKey: 'email', type: 'email', isRequired: true},
    ],
    [
        {name: 'taxAuthorityDepartment', labelKey: 'tax_authority_department', isRequired: true},
        {name: 'phone', labelKey: 'phone', type: 'tel'},
    ],
];

export const CREATE_EMPLOYEE_FIELDS_I18N = 'page_employers_control.create_employee.fields';
